namespace Matrix.Dashboards {
    export namespace WidgetCatalogService {
        export const baseUrl = 'Dashboards/WidgetCatalog';

        export declare function Create(request: Serenity.SaveRequest<WidgetCatalogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WidgetCatalogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WidgetCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WidgetCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Dashboards/WidgetCatalog/Create",
            Update = "Dashboards/WidgetCatalog/Update",
            Delete = "Dashboards/WidgetCatalog/Delete",
            Retrieve = "Dashboards/WidgetCatalog/Retrieve",
            List = "Dashboards/WidgetCatalog/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WidgetCatalogService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
